import {Navigate, useRoutes} from 'react-router-dom';
import {AppLayout} from './layout/appLayout';
import Home from './pages/Home';
import {Page404} from './pages/Page404';
import {LeaderBoard} from './pages/LeaderBoard';

export default function Router() {
  return useRoutes([
    {
      element: <AppLayout />,
      children: [
        {
          // path: "/",
          children: [
            // { path: "", element: <Navigate to="/" replace /> },
            {
              path: '/',
              element: <Home />,
            },
            {
              path: '/airspace',
              element: <Home />,
            },
            {
              path: '/leaderBoard',
              element: <LeaderBoard />,
            },
            {path: '404', element: <Page404 />},
            {path: '*', element: <Navigate to="/404" />},
          ],
        },
        {path: '*', element: <Navigate to="/404" replace />},
      ],
    },
  ]);
}
